function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { getNestedValue } from './../utils';
import { guid } from '@progress/kendo-vue-common';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
/**
 * @hidden
 */

var GridSelectionCell =
/** @class */
function (_super) {
  __extends(GridSelectionCell, _super);

  function GridSelectionCell() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputId = guid();
    return _this;
  }

  GridSelectionCell.prototype.handleOnChange = function (event) {
    this.$emit('selectionchange', {
      event: event,
      dataItem: this.$props.dataItem
    });
  }; // @ts-ignore


  GridSelectionCell.prototype.render = function (h) {
    var data = getNestedValue(this.$props.field, this.$props.dataItem);
    var renderTemplate = this.$props.render;
    var defaultRendering = this.$props.rowType !== 'groupHeader' ? h("td", {
      attrs: {
        colSpan: this.$props.colSpan
      },
      "class": this.$props.className
    }, [h("input", {
      domProps: {
        "checked": data
      },
      attrs: {
        id: this.inputId,
        type: "checkbox"
      },
      "class": "k-checkbox",
      on: {
        "change": this.handleOnChange
      }
    }), h("label", {
      "class": "k-checkbox-label",
      attrs: {
        "for": this.inputId
      }
    })]) : null;

    if (renderTemplate) {
      var events = __assign({
        change: this.handleOnChange
      }, this.$props.render.listeners);

      if (renderTemplate.type === 'slot') {
        return renderTemplate.render({
          props: this.$props,
          listeners: events,
          methods: events
        });
      } else if (renderTemplate.type === 'renderFunction') {
        return renderTemplate.render(h, defaultRendering, this.$props, events);
      } else {
        return h(renderTemplate.render, {
          props: this.$props,
          on: events
        });
      }
    } else {
      return defaultRendering;
    }
  };

  GridSelectionCell = __decorate([Component({
    props: {
      field: String,
      dataItem: Object,
      format: String,
      className: String,
      colSpan: Number,
      columnIndex: Number,
      columnsCount: Number,
      rowType: String,
      level: Number,
      expanded: Boolean,
      selectionChange: Function,
      onChange: Function,
      render: [String, Function, Object],
      editor: String // 'text' | 'numeric' | 'boolean' | 'date';

    }
  })], GridSelectionCell);
  return GridSelectionCell;
}(VueComponent);

export { GridSelectionCell };